import { APIClient } from './api';

interface EnvironmentDetailsConfig {
    environment: string;
    mapboxAccessToken: string;
    mapboxStyle: string;
    apiBaseUrl: string;
    languageIsoCode: string;
    areaId?: string;
    middlewareSecurityHeaderName?: string;
    middlewareSecurityHeaderValue?: string;
}

/**
 * @description Sets up the environment details for the Shared Repo. init method must be called in the entry file before importing components.
 * @class EnvironmentDetails
 * @implements {Partial<EnvironmentDetailsConfig>}
 */
class EnvironmentDetails implements Partial<EnvironmentDetailsConfig> {
    environment?: string;
    mapboxAccessToken?: string;
    mapboxStyle?: string;
    apiBaseUrl?: string;
    languageIsoCode?: string;
    areaId?: string;
    middlewareSecurityHeaderName?: string;
    middlewareSecurityHeaderValue?: string;

    init({
        environment,
        mapboxAccessToken,
        apiBaseUrl,
        mapboxStyle,
        languageIsoCode,
        areaId,
        middlewareSecurityHeaderName,
        middlewareSecurityHeaderValue,
    }: EnvironmentDetailsConfig) {
        this.environment = environment;
        this.mapboxAccessToken = mapboxAccessToken;
        this.mapboxStyle = mapboxStyle;
        this.apiBaseUrl = apiBaseUrl;
        this.languageIsoCode = languageIsoCode;
        this.areaId = areaId;
        this.middlewareSecurityHeaderName = middlewareSecurityHeaderName;
        this.middlewareSecurityHeaderValue = middlewareSecurityHeaderValue;

        APIClient.setBaseUrl(apiBaseUrl);
        if (this.middlewareSecurityHeaderValue && this.middlewareSecurityHeaderName) {
            APIClient.setSecurityHeaders(this.middlewareSecurityHeaderName, this.middlewareSecurityHeaderValue);
        }
    }

    get isLocal() {
        return this.environment === 'local';
    }

    get isTest() {
        return this.environment === 'test';
    }

    get isAcceptance() {
        return this.environment === 'acceptance';
    }

    get isProduction() {
        return this.environment === 'production';
    }
}

export const environmentDetails = new EnvironmentDetails();
